import React from 'react';

const DatalistTextInput = ({
  id,
  listId,
  value,
  onChange,
  onBlur,
  options = [],
  placeholder,
  disabled,
  required = false,
  onKeyDown,
  className = 'county-input-custom',
  style,
  'aria-label': ariaLabel
}) => (
  <>
    <input
      type="text"
      id={id}
      className={className}
      style={style}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      onKeyDown={onKeyDown}
      disabled={disabled}
      required={required}
      list={listId}
      placeholder={placeholder}
      aria-label={ariaLabel}
      autoComplete="off"
    />
    <datalist id={listId}>
      {options.map(opt => (
        <option key={opt} value={opt} />
      ))}
    </datalist>
  </>
);

export default DatalistTextInput;
